import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'

const QuestionnaireDetail = (props) => {
  const [detail, setDetail] = useState({})

  useEffect(() => {
    axios.post('/admin/forms/questionnaire/record/detail/get', {
      record_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title="筛查问卷详情"
      destroyOnClose={true}
      width='1000px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>

      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>提交表单</div>
          <div className='public-datail-content'>{detail.form_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>提交时间</div>
          <div className='public-datail-content'>{detail.submission_time}</div>
        </div>
        <div className='public-datail-item2'>
          <div className='public-datail-label'>用户填写</div>
          {detail.answers && (detail.answers.length > 0 && (detail.answers.map((item) => (
            <div className='public-datail-content2'>
              <div className='public-datail-content2-q'>{item.id}、{item.question || item.category}</div>
              <div className='public-datail-content2-a'>
                {item.type === 'multiple_choice' ? (
                  item.answer.join(' ｜ ') || '-'
                ) : (
                  <span>{item.answer || '-'}</span>
                )}
              </div>
            </div>
          ))))}
        </div>
      </div>
    </Modal>
  )
}

export default QuestionnaireDetail
